import ProjectEdit from "../components/page/ProjectEdit";

const ProjectSettings = () => {
  return (
      <ProjectEdit />
  );
};
export default ProjectSettings;
